import { render, staticRenderFns } from "./DetailContent.vue?vue&type=template&id=76fb8b2e&scoped=true"
import script from "./DetailContent.vue?vue&type=script&lang=js"
export * from "./DetailContent.vue?vue&type=script&lang=js"
import style0 from "./DetailContent.vue?vue&type=style&index=0&id=76fb8b2e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb8b2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76fb8b2e')) {
      api.createRecord('76fb8b2e', component.options)
    } else {
      api.reload('76fb8b2e', component.options)
    }
    module.hot.accept("./DetailContent.vue?vue&type=template&id=76fb8b2e&scoped=true", function () {
      api.rerender('76fb8b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/classManage/ClassOverviewDetail/components/CampusActivities/components/DetailContent.vue"
export default component.exports